import { Box } from "@chakra-ui/react";
import { useRouteMatch } from "react-router-dom";

// Custom Components.
import OptionsRow from "./OptionsRow";
import BuildingOption from "./BuildingOption";
import OptionsContainer from "./OptionsContainer";

// Images.
import PropertyType1 from "img/galleria/master-plan/zone-4/Type C main cover.png";
import PropertyType2 from "img/galleria/master-plan/zone-4/Type E main cover.png";
import PropertyType3 from "img/galleria/master-plan/zone-4/Type F main cover.png";
import PropertyType4 from "img/galleria/master-plan/zone-4/Type G main cover.png";
import PropertyType5 from "img/galleria/master-plan/zone-4/Type H main cover.png";

export default function AllBuildings() {
  const { path } = useRouteMatch();

  return (
    <OptionsContainer>
      <OptionsRow>
        <BuildingOption
          typeName="type-c"
          planUrl={`${path}/type-c/plan`}
          buildingName="Type C"
          image={PropertyType1}
        />
        <BuildingOption
          typeName="type-e"
          planUrl={`${path}/type-e/plan`}
          buildingName="Type E"
          image={PropertyType2}
        />
      </OptionsRow>
      <OptionsRow>
        <BuildingOption
          typeName="type-f"
          planUrl={`${path}/type-f/plan`}
          buildingName="Type F"
          image={PropertyType3}
        />
        <BuildingOption
          typeName="type-g"
          planUrl={`${path}/type-g/plan`}
          buildingName="Type G"
          image={PropertyType4}
        />
      </OptionsRow>
      <OptionsRow>
        <BuildingOption
          typeName="type-h"
          planUrl={`${path}/type-h/plan`}
          buildingName="Type H"
          image={PropertyType5}
        />
        <Box flex="1" h="100%" />
      </OptionsRow>
    </OptionsContainer>
  );
}
